import type { IconSvgObject } from './types';

const RestaurantTableIcon: IconSvgObject = [
  ["path", { d: "M5.5 17C3.83333 17 3.66667 16 2 16L4 9.5H20L22 16C20.3333 16 20.3333 17 18.6667 17C17 17 17 16 15.3333 16C13.6667 16 13.6667 17 12 17C10.3333 17 10.3333 16 8.66667 16C7 16 7.16667 17 5.5 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 9.5C18 6.18629 15.3137 3.5 12 3.5M6 9.5C6 6.18629 8.68629 3.5 12 3.5M12 3.5V2", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 17V22M12 22H14M12 22H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default RestaurantTableIcon;
